<template
  src="./index.html"
  lang="html"></template>
<style
  src="../../stylus/main.css"
  lang="css">
</style>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null
      },
      type: {
        type: String,
        default: 'text'
      },
      monterrey: {
        type: Boolean,
        default: false,
      },
      value: {
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      min: {
        type: String,
        default: null
      },
      max: {
        type: String,
        default: null
      },
      step: {
        type: Number,
        default: null
      },
      minlength: {
        type: Number,
        default: null
      },
      maxlength: {
        type: Number,
        default: null
      },
      required: {
        type: Boolean,
        default: true
      },
      autocomplete: {
        type: String,
        default: null
      },
      errorMessages: {
        type: [Array, String],
        default: null
      },
       uppercase: {
        type: Boolean,
        default: false
      },
      disabledPaste: {
        type: Boolean,
        default: false
      }
    },
    name: 'prv-input',
    data () {
      return {
        valueCopy: null,
        focus: false,
        valid: true,
        hasHidePassword: true
      }
    },
    computed: {
      computedErrors () {
        return typeof this.errorMessages === 'string' ? [this.errorMessages] : this.errorMessages;
      },
      computedClasses () {
        return {
          "material--active": this.focus,
          "material--active-mty": Boolean(this.focus && this.monterrey),
          "material--disabled": this.disabled,
          "material--has-errors": Boolean(
            !this.valid || (this.errorMessages && this.errorMessages.length)
          ),
          "material--raised": Boolean(
            this.focus || this.valueCopy || (this.placeholder && !this.valueCopy)
          ),
          "material--raised-mty": Boolean(
            this.monterrey &&
              (this.focus ||
                this.valueCopy ||
                (this.placeholder && !this.valueCopy))
          ),
        }
      }
    },
    methods: {
      handleModelInput (event) {
        let value = event.target.value;

        if (this.type === 'password') {
          value = value.replace(' ', '');
        }

        if (this.uppercase) {
          value = value.toUpperCase();
          event.target.value = value;
        }

        this.$emit('input', value, event);

        this.handleValidation();
      },
      handleFocus (focused) {
        this.focus = focused;
      },
      handleValidation () {
        this.valid = this.$el ? this.$el.querySelector('.material-input').validity.valid : this.valid;
      },
      copyValue (value) {
        this.valueCopy = value;
        this.handleValidation();
      },
      paste(evt) {
        if (this.disabledPaste) {
          evt.preventDefault();
        }
      },
      switchVisibility() {
        const passwordField = document.querySelector(`#${this.id}`);

        if (passwordField.getAttribute('type') === 'password') {

          this.hasHidePassword = false;

          passwordField.setAttribute('type', 'text')
        } else {

          this.hasHidePassword = true;

          passwordField.setAttribute('type', 'password')
        }
      }
    },
    watch: {
      value (newValue) {
        this.copyValue(newValue);
      }
    },
    beforeMount() {
      this.copyValue(this.value);
    }
  }
</script>